import React, { ReactElement, ReactNode } from 'react';
import { AppProps } from 'next/app';
import AppLayout from 'src/components/layouts/AppLayout';
import { ForumsPageProps } from 'src/types/NextApp';
import { appWithTranslation } from 'next-i18next';
import { NextPage } from 'next';
import nextI18nextConfig from 'next-i18next.config';

type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode
};

type AppPropsWithLayout<T> = AppProps & {
  Component: NextPageWithLayout<T>
};

export const App = ({ Component, pageProps }: AppPropsWithLayout<ForumsPageProps>) => {
  const getLayout = Component.getLayout ?? ((page) => page);
  return (
    <AppLayout>
      {getLayout(<Component {...pageProps} />)}
    </AppLayout>
  );
};

export default appWithTranslation(App, nextI18nextConfig);
